import { gql } from 'react-apollo';

export default gql`
  mutation updateInvestorFundQualification(
    $intendInvestingFunds: String
    $benefitInvestor: String
    $benefitInvestorQuestions: String
    $qualifiedPurchaserQuestion: String
    $qualifiedPurchaser: String
    $benefitInvestorQuestionsOther: String
    $qualifiedPurchaseOther: String
  ) {
    updateInvestorFundQualification(
      input: {
        intendInvestingFunds: $intendInvestingFunds
        benefitInvestor: $benefitInvestor
        benefitInvestorQuestions: $benefitInvestorQuestions
        qualifiedPurchaserQuestion: $qualifiedPurchaserQuestion
        benefitInvestorQuestionsOther: $benefitInvestorQuestionsOther
        qualifiedPurchaser: $qualifiedPurchaser
        qualifiedPurchaseOther: $qualifiedPurchaseOther
      }
    ) {
      _id
      canViewOffers
      intendInvestingFunds
      benefitInvestor
      benefitInvestorQuestions
      benefitInvestorQuestionsOther
      qualifiedPurchaserQuestion
      institutionalOther
      individualOther
      qualifiedPurchaser
      qualifiedPurchaseOther
    }
  }
`;



// WEBPACK FOOTER //
// ./src/apollo/mutations/updateInvestorFundQualification.js